<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <drivers-field-groups-edit-form
        @on-submit="onDriverFieldGroupEditSubmit"
      ></drivers-field-groups-edit-form>
    </div>
    <drivers-fields-overview></drivers-fields-overview>
  </div>
</template>
<script>
import DriversFieldGroupsEditForm from "./DriversFieldGroupsEditForm.vue";
import DriversFieldsOverview from "@/pages/Dashboard/Drivers/DriversFieldsOverview";

export default {
  components: {
    DriversFieldsOverview,
    DriversFieldGroupsEditForm
  },
  data() {
    return {
      holidayEditModel: {}
    };
  },
  methods: {
    onDriverFieldGroupEditSubmit(model) {
      this.holidayEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'holidayss/' + this.holidayEditModel.id, Object.assign(this.holidayEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
